import React from 'react';
import CustomScrollbar from 'js/common/components/CustomScrollbar';
import { showMessage } from 'js/modules/message/actions/MessageActions';
import { BOARD_MESSAGE_CONSTANT } from 'js/modules/message/constants/MessageConstants';
import { getI18NMessage } from 'I18N/I18NHelper';

class DropDown extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
            uploadImageUrl: this.props.dropdowncfg.uploadImageUrl,
            show: this.props.dropdowncfg.show,
            selected: this.props.dropdowncfg.selected
        };
    };

    componentWillReceiveProps() {
        this.updatePosition = true;

        this.setState({
            show: false
        });
    };

	render() {
        const that = this;

        if (this.props.dropdowncfg.list.length === 0) {
            return false;
        }

        const selectedItem = this.props.dropdowncfg.list.filter( item => (
            item.id === that.state.selected
        ) )[0] || this.props.dropdowncfg.list[0];
        const isUploadImage = this.state.selected === 'uploaded_image';
        let listScrollStyle = {
            height: '132px',
            width: '72px',
            ...this.state.style
        }

        if ( this.props.dropdowncfg.listStyle ) {
            listScrollStyle = Object.assign( {}, listScrollStyle, this.props.dropdowncfg.listStyle );
        }

		return (
            <div className='custom_drop_down_cnt' id={ this.props.dropdowncfg.id }>
                <div className={ `drop_down_selected float_left full_height cur_pointer ${ this.props.dropdowncfg.selectedElCls }` } 
                    style={ { ...selectedItem.style } } value={ this.state.selected || this.props.dropdowncfg.list[0].id } 
                    onMouseDown={ this.toggleList.bind(this) } title={ this.props.dropdowncfg.title }>
                    {
                        (selectedItem && selectedItem.bulletColor) && 
                            <div style={selectedItem.bulletStyle}></div>
                    }
                    {
                        ( isUploadImage || ( selectedItem && selectedItem.img ) ) &&
                            <img src={ ( isUploadImage && this.state.uploadImageUrl ) || selectedItem.img } className='vertical_align' alt='DropDown Selected Item'></img>
                    }
                    {
                        selectedItem && selectedItem.text && 
                            <span title={selectedItem.text}>{ selectedItem.text }</span>
                    }
                </div>
                <span className='float_left icon-down-filled-arrow drop_down_arrow vertical_align cur_pointer full_height' onMouseDown={ this.toggleList.bind(this) }></span>
                <CustomScrollbar className={ `drop_down_list_scroll_cnt ${this.state.show ? '' : 'hide'}` } style={ listScrollStyle }>                
                    <ul className={ `drop_down_list list_style_none list_bg pos_abs ${this.state.show ? '' : 'hide'}` }>
                        {
                            this.props.dropdowncfg.fileUploader &&
                                <li className='file_uploader file_uploader_bg cur_pointer' onClick={ this.openFileSelector.bind(this) }>
                                    <span className='icon-attachment-clip float_left vertical_align'></span>
                                    <span className='vertical_align float_left'>Attach</span>
                                    <input type='file' className='pos_abs full_width' accept='image/*' onChange={ this.onFileUpload.bind(this) }></input>
                                </li>
                        }
                        {
                            this.props.dropdowncfg.list.map(item => (
                                <li value={ item.id } key={ item.id } className={ `cur_pointe ${ item.cls }`} onMouseDown={ this.onListItemClick.bind(this) } style={ { ...item.style } } title={ item.title }>
                                    {
                                        item.bulletStyle && 
                                            <div style={item.bulletStyle}></div>
                                    }
                                    {
                                        item.img && 
                                            <img src={ item.img } alt='DropDown Item'></img>
                                    }
                                    {
                                        item.text && 
                                            <span title={selectedItem.text}>{ item.text }</span>
                                    }
                                </li>
                            ))
                        }
                    </ul>
                </CustomScrollbar>
            </div>            
        );
    };

     /* istanbul ignore next */
    componentDidUpdate() {
        const listContainer = document.getElementById(this.props.dropdowncfg.id);
        const list = listContainer && listContainer.getElementsByClassName('drop_down_list_scroll_cnt')[0];

        if ( this.props.dropdowncfg.dropdownPostion === 'top' && this.updatePosition && this.state.show ) {
            this.updatePosition = false;
            this.setState({
                style: {
                    top: -( list.offsetHeight * 1.8 ) + 'px'
                }
            });
        } else if ( this.updatePosition && this.state.show && this.props.dropdowncfg.container && this.props.dropdowncfg.id ) {
            const container = document.getElementById( this.props.dropdowncfg.container );
            const containerHeight = container.offsetHeight;

            this.updatePosition = false;

            if ( list.offsetHeight > containerHeight - ( list.getBoundingClientRect().top - container.getBoundingClientRect().top ) ) {
                const top = listContainer.getBoundingClientRect().top - list.offsetHeight - listContainer.offsetHeight * 1.8;
                
                this.setState({
                    style: {
                        position: 'fixed',
                        top: top + 'px'
                    }
                });
            } else {
                this.setState({
                    style: {}
                });
            }
        } else if ( this.updatePosition && !this.state.show ) {
            this.updatePosition = false;

            this.setState({
                style: {}
            });
        }
    };
    
     /* istanbul ignore next */
    toggleList( event ) {
        event.preventDefault();
        this.updatePosition = true;

        this.setState({
            show: !this.state.show
        });
    };

     /* istanbul ignore next */
    onListItemClick( event ) {
        event.preventDefault();
        this.updatePosition = true;

        if ( this.props.dropdowncfg.fileUploader ) {
            event.currentTarget.closest('.custom_drop_down_cnt').getElementsByTagName('input')[0].value = '';
        }

        this.setState({
            show: false,
             selected: event.currentTarget.getAttribute('value')
        });

        if ( this.props.onChange ) {
            this.props.onChange( event, this.props, event.currentTarget.getAttribute('value'));
        }
    };

     /* istanbul ignore next */
    onListScroll( event ) {
        event.stopPropagation();
    };

     /* istanbul ignore next */
    openFileSelector( event ) {
        event.currentTarget.getElementsByTagName('input')[0].click();
    };

     /* istanbul ignore next */
    onFileUpload( event ) {
        if ( event.currentTarget.files && event.currentTarget.files.length > 0 ) {
            if ( this.props.dropdowncfg.allowedFileTypes && 
                this.props.dropdowncfg.allowedFileTypes.indexOf( event.currentTarget.files[0].type.split('/')[1] ) === -1 ) {
                    this.props.store.dispatch( showMessage({
                        type: BOARD_MESSAGE_CONSTANT.TYPE_ERROR,
                        message: getI18NMessage( 'invalidFileTypeMsg' )
                    }) );
        
                    event.currentTarget.value = '';
            } else if ( this.props.dropdowncfg.maxFileSize && event.currentTarget.files[0].size > this.props.dropdowncfg.maxFileSize ) {
                this.props.store.dispatch( showMessage({
                    type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
                    message: this.props.dropdowncfg.maxFileErrorMsg || getI18NMessage( 'fileSizeErrorMsg' )
                }) );
    
                event.currentTarget.value = '';
            } else {
                this.setState( {
                    selected: 'uploaded_image',
                    uploadImageUrl: URL.createObjectURL( event.currentTarget.files[0] ),
                    show: false
                } );
            }
        }
    };
}

export default DropDown;